'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/X.es.js";
const e = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: a$1 }));
e.displayName = "XIcon";
const n = e;
export {
  n as X,
  e as XIcon
};
